import type { Maybe } from '@adornis/base/utilTypes.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery } from '@adornis/functional-lit/use-query.js';
import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { of } from 'rxjs';
import { SepaAPI } from '../api/SepaAPI.js';
import { SepaMandat } from '../entities/SepaMandat.js';
import { SepaCardSkeleton, SepaMandateCard } from './SepaMandateCard.js';
import { uniqueID, withTemplates } from './UserSepaMandateList.js';

export const SgDonations = stateful((props: { personID: Maybe<string> }) => {
  const { value: sepaMandats, loading: sepaMandatsLoading } = useQuery(
    () =>
      props.personID
        ? SepaAPI.subscribeMandats(props.personID, 'Elternengagement')(selectionSet(() => SepaMandat, 1))
        : of([]),
    [props.personID],
  );

  const { value: sepaMandatTemplates, loading: sepaMandatTemplatesLoading } = useQuery(
    () =>
      props.personID
        ? SepaAPI.getTemplates(props.personID, 'Elternengagement')(selectionSet(() => SepaMandat, 1))
        : of([]),
    [props.personID, sepaMandats],
  );

  if (sepaMandatsLoading || sepaMandatTemplatesLoading) {
    return html` <div class="flex flex-row flex-wrap gap-4 m-4">${SepaCardSkeleton()} ${SepaCardSkeleton()}</div>`;
  }

  return html`
    <div class="flex flex-col gap-4 p-4">
      <div class="card p-4 gap-4">
        <p>
          Alle SEPA-Mandate für Spenden (freiwilliges Elternengagement) werden über das Portal verwaltet. Alle
          schriftlich erteilten Mandate werden in das Portal übergeleitet und werden nicht zusätzlich erteilt.
        </p>
        <p>
          Das heißt: Alle Ihre regelmäßigen Spenden, die der Schulgesellschaft bekannt sind, sehen Sie unten - auch die,
          welche auf Papier erteilt wurden. Nur die untenstehende Spenden werden ggf. abgebucht.
        </p>
        <p class="font-bold">Herzlichen Dank!</p>
      </div>

      <div class="flex gap-4 wrap">
        ${repeat(withTemplates(sepaMandats ?? [], sepaMandatTemplates ?? []), uniqueID, m =>
          SepaMandateCard({ mandat: m, userID: props.personID }),
        )}
      </div>

      <div class="h-32"></div>
    </div>
  `;
});
